export default __webpack_public_path__ + "b7886fbfbf41a5e3c19f1d5af247fc66.png";